import styled from 'styled-components';
import { Text } from '@audio-network/componentlibrary';
export var DetailsContainer = styled.div.withConfig({
  displayName: "TrackDetailsstyles__DetailsContainer",
  componentId: "sc-m6i5lp-0"
})(["display:flex;grid-area:info;flex-direction:column;justify-content:center;width:12rem;overflow-x:hidden;height:48px;"]);
export var Scroller = styled.div.withConfig({
  displayName: "TrackDetailsstyles__Scroller",
  componentId: "sc-m6i5lp-1"
})(["position:relative;&:after{pointer-events:none;content:' ';z-index:1;position:absolute;top:0;right:0;height:100%;width:100%;background:linear-gradient( to right,", " ", ",", " 100% );}"], function (_ref) {
  var theme = _ref.theme;
  return "".concat(theme.colors.backgroundPrimary, "00");
}, function (_ref2) {
  var isScrollable = _ref2.isScrollable;
  return isScrollable ? '90%' : '100%';
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.backgroundPrimary;
});
export var TitleWrapper = styled.div.withConfig({
  displayName: "TrackDetailsstyles__TitleWrapper",
  componentId: "sc-m6i5lp-2"
})(["min-height:1.625rem;&:hover{* a{border-bottom:2px solid ", ";}}"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.textPrimary;
});
export var Title = styled(Text).withConfig({
  displayName: "TrackDetailsstyles__Title",
  componentId: "sc-m6i5lp-3"
})(["font-weight:600;white-space:nowrap;overflow:hidden;", " border-bottom:none;margin-right:1rem;border-bottom:2px solid transparent;"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.typography.bodyM;
});
export var Composer = styled(Text).withConfig({
  displayName: "TrackDetailsstyles__Composer",
  componentId: "sc-m6i5lp-4"
})(["", " text-decoration:none;&:is(a):hover{text-decoration:underline;}"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.typography.bodyS;
});
export var Composers = styled.div.withConfig({
  displayName: "TrackDetailsstyles__Composers",
  componentId: "sc-m6i5lp-5"
})(["line-height:0.75rem;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;"]);